var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.loading)?_c('Loading',{attrs:{"text":_vm.$t('finish-loading')}}):_vm._e(),(_vm.error)?_c('h3',[_vm._v(_vm._s(_vm.error))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }